import React, { ReactElement } from "react";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import { useLoaderData } from "react-router-dom";
import { hasPermission } from "../lib/auth";
import {
    ForbiddenErrorPage,
    ForbiddenPowerUserErrorPage,
} from "../pages/ErrorPage";
import { graphql } from "babel-plugin-relay/macro";
import { PrivateRouteQuery } from "./__generated__/PrivateRouteQuery.graphql";

export const privateRouteQuery = graphql`
    query PrivateRouteQuery {
        currentUser {
            permissions {
                allow
                deny
            }
        }
    }
`;

interface restrictedPagePermissionsProps {
    children: ReactElement;
    expectedAllowPermission: string;
}

export function PrivateRoute({
    children,
    expectedAllowPermission,
}: restrictedPagePermissionsProps) {
    const { privateRouteLoadedQuery } = useLoaderData() as {
        privateRouteLoadedQuery: PreloadedQuery<PrivateRouteQuery>;
    };
    const userPermission = usePreloadedQuery(
        privateRouteQuery,
        privateRouteLoadedQuery,
    );

    const canViewPage = hasPermission(
        userPermission.currentUser.permissions,
        expectedAllowPermission,
    );

    if (!canViewPage) {
        if (
            hasPermission(
                userPermission.currentUser.permissions,
                "power-user-scope",
            )
        ) {
            return <ForbiddenPowerUserErrorPage></ForbiddenPowerUserErrorPage>;
        } else {
            return <ForbiddenErrorPage></ForbiddenErrorPage>;
        }
    }

    return children;
}
